<script>
    export default {
        data() {
            return {
                productsAddedToCart: false,
            };
        },
        computed: {
            monthlyPrice() {
                if (this.selectedCampaign !== null) {
                    return format_sek_per_month(this.getAttributeFromSelected('discounted_monthly_price'));
                }

                if (this.selectedProduct === null) {
                    return '-';
                }

                if (typeof this.getAttributeFromSelected('monthly_price') === 'number') {
                    return format_sek_per_month(this.getAttributeFromSelected('monthly_price'));
                }

                return '-';
            },
            startFee() {
                return this.getAttributeFromSelected('start_fee');
            },
            bindingPeriodLabel() {
                const value = this.getAttributeFromSelected('binding_period_label');
                return value !== '' ? value : '-';
            },
            terminationTimeLabel() {
                const value = this.getAttributeFromSelected('termination_time_label');
                return value !== '' ? value : '-';
            },
            startFeeLabel() {
                const value = this.getAttributeFromSelected('start_fee');
                return value !== '' ? format_sek(value) : '-';
            },
            selectedCampaignHasRouter() {
                return !! (this.selectedCampaign && this.selectedCampaign.routers);
            },
        },
        created() {
            if (this.campaigns && this.campaigns.length) {
                this.setCampaign(this.campaigns[0]);
            }
        },
        methods: {
            getAttributeFromSelected(attribute, fallback = '') {
                if (typeof this.selectedProductObject !== 'undefined') {
                    return this.selectedProductObject[attribute];
                }

                if (this.selectedProduct !== null) {
                    return this.selectedProduct[attribute];
                }

                if (this.selectedCampaign !== null) {
                    return this.selectedCampaign[attribute];
                }

                return fallback;
            },
            getCampaignPrice(campaign) {
                return format_sek_per_month(campaign.discounted_monthly_price) + ' '
                    + lang(`i ${campaign.discount_months} månader`, `for ${campaign.discount_months} months`);
            },
            getCampaignAfterPrice(campaign) {
                return lang('Därefter', 'Then') + ' ' + format_sek_per_month(campaign.monthly_price);
            },
            selectCustomProduct(product) {
                this.selectedProduct = product;
            },
            setProduct(newProduct) {
                this.selectedProduct = newProduct;
                this.selectedCampaign = null;
            },
            selectCampaign(campaign) {
                this.selectedCampaign = campaign;
            },
        },
    };
</script>
